export default __webpack_public_path__ + "static/media/3334 spice rack E top.176c4478.png";